import React from 'react'
import reactStamp from 'react-stamp'
import './register.css'
import RegisterForm from './RegisterForm'
import Background from '../Background'
import MediaQuery from 'react-responsive'

export default reactStamp(React).compose({

    render() {

        return (
            <div>
                <Background />

                <MediaQuery maxWidth={920}>
                <div className="form-panel-container form-panel-container-mobile">
                    <h2 className="registration">Registration</h2>
                        <RegisterForm handleSubmit={this.props.handleSubmit} mobile={true} emailError={this.props.emailError}/>
                </div>
                </MediaQuery>
                <MediaQuery minWidth={920}>
                    <div className="form-panel-container">
                        <h2 className="registration">Registration</h2>
                        <RegisterForm handleSubmit={this.props.handleSubmit} emailError={this.props.emailError}/>
                    </div>
                </MediaQuery>

            </div>
        );
    },

});


/** WEBPACK FOOTER **
 ** ./src/app/components/Register/index.js
 **/